import { render, staticRenderFns } from "./modalDetalleImage.vue?vue&type=template&id=27cd3458"
import script from "./modalDetalleImage.vue?vue&type=script&lang=js"
export * from "./modalDetalleImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports